import {
  Box,
  Text,
  Image,
  ListItem,
  UnorderedList,
  Center,
} from "@chakra-ui/react";
import profImage from "../images/profImage.jpg";

export default function Introduction(props) {
  return (
    <div {...props}>
      <Box
        display="flex"
        justifyContent="space-between"
        flexDir={{
          base: "column",
          md: "row",
          xl: "row",
        }}
        align-items="center"
        width={{ base: "90%", md: "77%", lg: "77%" }}
        ml="auto"
        mr="auto"
        mt="80px"
      >
        <Box
          display="flex"
          flexDir="row"
          alignItems="center"
          background="rgba(31, 159, 181, 0.3)"
          flexGrow="1"
          pl="10px"
          pr="auto"
          pt="6px"
          mr={{ base: "0", md: "35", lg: "70" }}
          borderRadius={3}
        >
          <Text
            color="white"
            fontSize={{ base: "xl", md: "2xl", lg: "3xl" }}
            fontWeight={700}
          >
            "Our AI technology is specifically designed to support skilled
            pediatric urologists globally by understanding and complementing
            their existing workflows, thereby enabling them to manage
            hypospadias anomalies more efficiently."
          </Text>
        </Box>
        <Box
          display="flex"
          flexDir="column"
          align-items="center"
          flexShrink="0"
          width={{ base: "100%", md: "250px", xl: "323px" }}
          background="rgba(31, 159, 181, 0.3)"
          pl=" 31px"
          pr=" 31px"
          pt="15px"
          mt={{ base: "50px", md: "0", xl: "0" }}
          borderRadius={3}
        >
          <Center>
            <Image
              src={profImage}
              alt="dr-tariq-abbas-image"
              width={{ base: "60%", md: "60%", xl: "100%" }}
              borderRadius={3}
            />
          </Center>
          <Text
            color="white"
            fontSize="18px"
            fontWeight={700}
            textAlign="center"
            mt={3}
            mb={3}
          >
            DR. Tariq Abbas
          </Text>
          <Text color="white" fontSize="14px">
            MBBS, IMRCS(Ire.), FEBPS, CAB GPS, FEAPU(Int.), PhD (Cand.).
          </Text>
          <UnorderedList color="white" fontSize="14px" mb={3}>
            <ListItem>
              Pediatric Urologist, Hamad General Hospital, Doha, Qatar.
            </ListItem>
            <ListItem>
              Assistant Professor, Weill-Cornell Medical College-Qatar.
            </ListItem>
            <ListItem>
              Clinical Lecturer, College of Medicine, Qatar University.
            </ListItem>
          </UnorderedList>
        </Box>
      </Box>
    </div>
  );
}
